
























































import { Component, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { Worklist, EPromotionStatus } from '@/services/connecteur'
import { dateShortFormat } from '@/filters/dateFormat'
import * as signalR from '@microsoft/signalr'
import promotionModule from '@/store/modules/PromotionModule'
import userModule from '@/store/modules/UserModule'

@Component({
  filters: {
    dateShortFormat
  }
})
export default class WorklistView extends Mixins(BaseVue) {
  public EPromotionStatus = EPromotionStatus

  public hubConnexion!: signalR.HubConnection

  public created () {
    promotionModule.fetchWorkList()
    this.hubConnexion = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_BACK_URL || '' + '/worklistHub', {
        accessTokenFactory: () => userModule.token
      })
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect()
      .build()

    this.hubConnexion.on('UpdateClientWorklist', data => {
      promotionModule.fetchWorkList()
    })

    this.hubConnexion.start()
  }

  public beforeDestroyed () {
    this.hubConnexion.stop()
  }

  public redirectToPromotion (item: Worklist) {
    this.$router.push('/promotion/' + item.id)
  }

  public get workingList (): Worklist[] {
    return promotionModule.worklist
  }

  public get workListLength (): number {
    if (promotionModule && promotionModule.worklist) {
      return promotionModule.worklist.length
    }

    return 0
  }

  public getDPName (work: Worklist) {
    if (work && work.demandPlannerList) {
      return work.demandPlannerList.map(dp => dp.fullName).join(', ')
    }

    return this.$t('userRole.DEMAND_PLANNER')
  }
}
